var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/DynamicGroup/DynamicGroupCondition.ts";
import * as t from 'io-ts';
import { Id } from '../../Id';
import { Version } from '../../Version';
import { ElementProperty } from './ElementProperty';
export var DynamicGroupCondition;

(function (_DynamicGroupCondition) {
  var Data = _DynamicGroupCondition.Data = t.type({
    id: Id,
    classifierId: Id,
    classifierVersion: Version,
    sourceGroupId: Id,
    groupingConditions: t.array(ElementProperty.io)
  });
})(DynamicGroupCondition || (DynamicGroupCondition = {}));